import { Image } from "@/generated/graphql";

export function isGif(image: Image | undefined | null) {
  return !!image?.src?.includes?.(".gif");
}
